import { render, staticRenderFns } from "./VMultiselectItem.vue?vue&type=template&id=4d3f9d03&lang=pug&"
import script from "./VMultiselectItem.vue?vue&type=script&lang=js&"
export * from "./VMultiselectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports